module.exports = __webpack_public_path__ + "static/img/qtcj04.e4d7eab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qtcj04.png
// module id = 464
// module chunks = 0